<template>
  <v-row no-gutters>
    <v-col
      cols="7"
      class="list-object-name"
    >
      <h2>{{ object.objectName }}</h2>
    </v-col>
    <v-col
      cols="5"
      class="text-right"
    >
      {{ $i18n.t('csr_id') }}: {{ object.csrId }}
    </v-col>
    <v-col
      cols="12"
      :class="'list-address ' + ($store.state.homepage ? 'pb-2' : 'pb-0')"
    >
      <h2>{{ object.address }}</h2>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ListObjectTitle',

  props: {
    object: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
